import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { SeoService } from '../services';

@Component({
    selector: 'tdms-nocontent',
    templateUrl: './no-content.component.html',
    styleUrls: ['./_no-content.component.scss'],
    standalone: false
})
export class NoContentComponent implements OnInit {

  constructor (
      private _seoSvc: SeoService,
      private location: Location
  ) {
    this._seoSvc.setTitle('Page Not Found');
  }

  public ngOnInit () {
  }

  back () {
    this.location.back();
  }
}
